import React from 'react' // eslint-disable-line no-unused-vars
import '../../css/forms/default-forms.css'
import { connect } from 'react-redux'
import { RingLoader } from 'react-spinners'
import Footer from '../Footer'
import { isMobileDevice } from '../../functions.js'
import { getCookie } from '../../helpers/CookieHandler'
import { push } from 'react-router-redux'
import { v4 as uuidv4 } from 'uuid'

class SiteMap extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      searching: false
    }

    this.componentName = 'SiteMap'
  }

  _showNotification = (title, message, status) => {
    const { notify } = this.props
    notify({
      title,
      message,
      status,
      position: 'tr',
      dismissible: true,
      dismissAfter: 3000
    })
  }

  getMenuItemTitle = (menu, useShortTitle, lang) => {
    const tran = menu.translations.filter(item => item.lang === lang)[0]
    const title = useShortTitle ? tran.shortTitle : tran.title

    return title
  }

  getMenuItemDescription = (menu, lang) => {
    const tran = menu.translations.filter(item => item.lang === lang)[0]
    return tran.description
  }

  render () {
    let lang = 'en'
    const cookieLang = getCookie('welcomeLanguage')
    if (cookieLang && cookieLang.length === 2) {
      lang = cookieLang
    }

    const languageContent = this.props.pageContent.content

    const formTitle = languageContent.page.HOME.siteMap

    return (
      <div className='page-container'>
        <div className='page-content'>
          <div className='container' style={{ border: '0px solid blue', marginBottom: '5px' }}>
            {isMobileDevice()
              ? (
                <div>
                  <h3 className='mb-3 header-primary'>
                    {formTitle}
                  </h3>
                </div>)
              : (
                <div>
                  <h3 className='mb-3 header-primary'>
                    {formTitle}
                  </h3>
                </div>)}
            <div className='col-xl-12'>
              <RingLoader color='#071d49' loading={this.state.searching} />
            </div>
            <div className='row'>
              <div className='col-xl-12 m-t-20 m-b-10'>
                <h5><b>{this.props.navigation.siteMap.sections.globalNavigation.title.translations.filter(item => item.lang === lang)[0].value}</b></h5>
              </div>
              {this.props.navigation.items.map((menu, i) =>
                <div
                  className='col-lg-4 col-xl-4 m-b-20'
                  key={`feedback${uuidv4()}`}
                >
                  <a
                    role='button'
                    onClick={() => (this.props.dispatch(push(menu.url)))}
                  >
                    <span style={{
                      fontSize: '16px',
                      fontWeight: 'bold',
                      wordBreak: 'break-word',
                      borderBottom: '1px solid #2f9ece',
                      color: '#071D49'
                    }}
                    >
                      {this.getMenuItemTitle(menu, false, lang)}
                    </span>
                  </a>
                  <p className='m-t-5'>{this.getMenuItemDescription(menu, lang)}</p>
                </div>
              )}
            </div>
            <div className='row'>
              <div className='col-xl-12 m-t-10 m-b-10'>
                <h5><b>{this.props.navigation.siteMap.sections.about.title.translations.filter(item => item.lang === lang)[0].value}</b></h5>
              </div>
              {this.props.navigation.siteMap.sections.about.items.map((menu, i) =>
                <div
                  className='col-lg-4 col-xl-4 m-b-20'
                  key={`externalLink${uuidv4()}`}
                >
                  <div className='site-map-external-link'>
                    <a
                      href={menu.url}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <span style={{
                        wordBreak: 'break-word',
                        borderBottom: '1px solid #2f9ece',
                        color: '#071D49'
                      }}
                      >
                        {this.getMenuItemTitle(menu, false, lang)}
                      </span>
                    </a>
                  </div>
                  <p className='m-t-5'>{this.getMenuItemDescription(menu, lang)}</p>
                </div>
              )}
            </div>
            <div className='row'>
              <div className='col-xl-12 m-t-0 m-b-10'>
                <h5><b>{this.props.navigation.siteMap.sections.legal.title.translations.filter(item => item.lang === lang)[0].value}</b></h5>
              </div>
              {this.props.navigation.siteMap.sections.legal.items.map((menu, i) =>
                <div
                  className='col-lg-4 col-xl-4 m-b-20'
                  key={`externalLink${uuidv4()}`}
                >
                  <div className='site-map-external-link'>
                    <a
                      href={menu.url}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <span style={{
                        wordBreak: 'break-word',
                        borderBottom: '1px solid #2f9ece',
                        color: '#071D49'
                      }}
                      >
                        {this.getMenuItemTitle(menu, false, lang)}
                      </span>
                    </a>
                  </div>
                  <p className='m-t-5'>{this.getMenuItemDescription(menu, lang)}</p>
                </div>
              )}
            </div>
          </div>
          <div style={{ paddingTop: '100px' }}>
            <span>&nbsp;</span>
          </div>
        </div>
        <Footer />
      </div>)
  }
}

const mapStateToProps = ({ permissions, pageContent, config, navigation }, ownProps) => (
  {
    permissions,
    pageContent,
    config,
    navigation: navigation[0]
  })
export default connect(mapStateToProps)(SiteMap)



// WEBPACK FOOTER //
// ./src/mi-app/siteMap/SiteMap.js